import styled from '@emotion/styled';
import { BREAKPOINTS, COLORS, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT, SPACE } from '@/constants';
import Link from 'next/link';

export const CalloutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE.X0};
  padding: 1rem;
  border-radius: 0.25rem;
  background: ${COLORS.GREY_THREE};

  p {
    margin: 0;
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${LINE_HEIGHT.BODY.SMALL};
  }
`;

export const CalloutTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE.X0};
`;

export const CalloutIconWrapper = styled.div`
  border-radius: 100%;
  aspect-ratio: 1/1;
  width: ${SPACE.X2};
  height: ${SPACE.X2};
  font-size: ${FONT_SIZE.X_LARGE};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.BRAND_YELLOW_SEVEN};
`;

export const CalloutLink = styled(Link)`
  color: ${COLORS.BRAND_BLUE_EIGHT};
  font-weight: ${FONT_WEIGHT.BOLD};
  text-decoration: none;
  user-select: none;
  font-size: ${FONT_SIZE.X_SMALL};

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${BREAKPOINTS.SM}px) {
    font-size: ${FONT_SIZE.SMALL};
  }
`;
